function getParam(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}


$(function () {
  let searchKeyWord = getParam('p');
  let searchTagWord = getParam('tg');
  let sort_by = getParam('sort_by');
  let page_no = getParam('page');
  page_no = (page_no && (page_no >= 1)) ? page_no : 1;

  $('#SortBy').on('change', function () {
    window.location.href = pageUrlCreate(1,$(this).val());
  });

  $('.error_msg_product').text('')
  $('.error_msg_recipe').text('')


  if (searchKeyWord) {
    let addText = searchKeyWord;
    $('#search_text').text(addText);
  }

  if (searchTagWord) {
    let addText = '＃' + searchTagWord;
    $('#search_text').text(addText);
  }

  function pageUrlCreate(pageNo, sortBy) {
    let return_url = location.pathname + '?page=' + pageNo;
    if (searchKeyWord) {
      return_url += '&p=' + searchKeyWord;
    } else if(searchTagWord) {
      return_url += '&tg=' + searchTagWord;
    }
    if (sortBy) {
      return_url += '&sort_by=' + sortBy;
    }
    return return_url
  }

  switch (sort_by) {
    case 'created-descending':
      $itemArray.sort(function (a, b) {
        return (a.published_at < b.published_at ? 1 : -1);
      });
      break;
    default:
      $itemArray.sort(function (a, b) {
        return b.price - a.price;
      });
      break;
  }

  console.log($itemArray);



  if(sort_by) {
    $('#SortBy').val(sort_by);
  }



  let pagination_id_name = '#pagination';
  let collectionItem = '#collection_item';
  let viewCout = 12;

  let currentPage = page_no;
  let startSlice = (currentPage - 1) * viewCout;
  let endSlice = viewCout * currentPage;


  let $itemResultArray = $.grep($itemArray,
    function (elem, index) {
      if (searchKeyWord) {
        regexp = new RegExp(searchKeyWord + '(.*?)', 'g');
        return (elem.title.match(regexp));
      } else if (searchTagWord) {
        return (elem.tags.indexOf(searchTagWord) > -1);
      }
    }
  );
  let $firstItemArray = $itemResultArray.slice(startSlice, endSlice);
  let max_page_count = Math.ceil($itemResultArray.length / viewCout);

  if (!$firstItemArray.length) {
    // ０件の場合
    $(pagination_id_name).css({ 'display': 'none' });
    $('.error_msg_product').text('対象の商品はございません。');
    $('.order_form').css({'display':'none'});
  }


  let page_no_extent = [
    (Number(currentPage) - 2),
    (Number(currentPage) - 1),
    (Number(currentPage)),
    (Number(currentPage) + 1),
    (Number(currentPage) + 2),
  ]

  for (let i = 1; i <= max_page_count; i++) {
    let dom = '';
    let page_url = pageUrlCreate(i,sort_by);
    if (currentPage == i) {
      dom = '<li>' +
        '<div class="current {% if paginate.current_page != pageurl.title  %}ellipsis{% endif %}">' +
        '<p>' + i + '</p>' +
        '</div>' +
        '</li>';
    } else if (page_no_extent.indexOf(i) >= 0) {
      dom = '<li>' +
        '<a class="page_link" href="' + page_url + '">' +
        '<p>' + i + '</p>' +
        '</a>' +
        '</li>';
    }
    $('#page_number').append(dom);
  }

  // ページネーション先(_・ω・)_ ﾊﾞｧﾝ処理
  if (1 != currentPage && (page_no_extent.indexOf(1) < 0)) {
    let page_url = pageUrlCreate(1,sort_by);
    let dom = '';
    dom += '<li>' +
      '<a class="page_link" href="' + page_url + '">' +
      '<p>' + 1 + '</p>' +
      '</a>' +
      '</li>';
    if ((page_no_extent.indexOf(2) < 0)) { // 2が存在しないとき...をつける
      dom +=
        '<li>' +
        '<div class="current ellipsis">' +
        '<p>…</p>' +
        '</div>' +
        '</li>';
    }
    $('#page_number').prepend(dom);
  }

  // ページネーション後(_・ω・)_ ﾊﾞｧﾝ処理
  if (max_page_count > currentPage && (page_no_extent.indexOf(max_page_count) < 0)) {
    let page_url = pageUrlCreate(max_page_count,sort_by);

    let max_prev_count = (Number(max_page_count) - 1);
    let dom = ''
    if ((page_no_extent.indexOf(max_prev_count) < 0)) { // max_prev_countが存在しないとき...をつける
      dom +=
        '<li>' +
        '<div class="current ellipsis">' +
        '<p>…</p>' +
        '</div>' +
        '</li>';
    }
    dom += '<li>' +
      '<a class="page_link" href="' + page_url + '">' +
      '<p>' + max_page_count + '</p>' +
      '</a>' +
      '</li>';
    $('#page_number').append(dom);
  }


  if (currentPage == 1) {
    let dom =
      '<button class="prev page_move" disabled>' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="17.414" height="9.414" viewBox="0 0 17.414 9.414"><path d="M1364.1,786.737l8,7.83-8,8.17" transform="translate(-786.03 1372.805) rotate(-90)" fill="none" stroke="#ee220c" stroke-linecap="round" stroke-width="1"/></svg>' +
      '</button>';
    $(pagination_id_name).prepend(dom);
  } else {
    let page_url = pageUrlCreate((Number(currentPage) - 1),sort_by);
    let dom = '<a href="' + page_url + '" class="prev page_move">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="17.414" height="9.414" viewBox="0 0 17.414 9.414"><path d="M1364.1,786.737l8,7.83-8,8.17" transform="translate(-786.03 1372.805) rotate(-90)" fill="none" stroke="#ee220c" stroke-linecap="round" stroke-width="1"/></svg>' +
      '</a>';
    $(pagination_id_name).prepend(dom);
  }

  if (currentPage == max_page_count) {
    let dom =
      '<button class="next page_move" disabled>' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="17.414" height="9.414" viewBox="0 0 17.414 9.414"><path d="M1364.1,786.737l8,7.83-8,8.17" transform="translate(-786.03 1372.805) rotate(-90)" fill="none" stroke="#ee220c" stroke-linecap="round" stroke-width="1"/></svg>' +
      '</button>';
    $(pagination_id_name).append(dom);
  } else {
    let page_url = pageUrlCreate((Number(currentPage) + 1),sort_by);
    let dom = '<a href="' + page_url + '" class="next page_move">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="17.414" height="9.414" viewBox="0 0 17.414 9.414"><path d="M1364.1,786.737l8,7.83-8,8.17" transform="translate(-786.03 1372.805) rotate(-90)" fill="none" stroke="#ee220c" stroke-linecap="round" stroke-width="1"/></svg>' +
      '</a>';
    $(pagination_id_name).append(dom);
  }

  collectionItemView($firstItemArray);

  function collectionItemView($productArray) {
    $.each($productArray, function (i, citem) {
      var addDom = '<li>' +
        '<a href="' + citem['url'] + '">' +
        '<div class="thumbnail">' +
        '<img src="' + citem['img'] + '" alt="' + citem['title'] + '">' +
        '</div>' +
        '<p class="name">' + citem['title'] + '</p>' +
        '<p class="detail">' + citem['content'] + '</p>' +
        '<p class="jancode">JANコード:<br class="sp"><span>' + citem['jancode'] + '</span></p>' +
        '<div class="more">' +
        '<p>商品情報を見る &gt;</p>' +
        '</div>' +
        '</a>' +
        '</li>';
      $(collectionItem).append(addDom);
    })
  }
});